const ADMILL_SCRIPT_ID_LOGIN = 'admill-script-login';
const ADMILL_NOSCRIPT_ID_LOGIN = 'admill-noscript-login';
const  ADMILL_SCRIPT_ID_ALLPAGE = 'admill-script-allpage';
const  ADMILL_NOSCRIPT_ID_ALLPAGE = 'admill-noscript-allpage';
const  ADMILL_SCRIPT_ID_REGISTER = 'admill-script-register';
const  ADMILL_NOSCRIPT_ID_REGISTER = 'admill-noscript-register';

export {
    ADMILL_NOSCRIPT_ID_LOGIN, 
    ADMILL_SCRIPT_ID_LOGIN, ADMILL_SCRIPT_ID_ALLPAGE, 
    ADMILL_NOSCRIPT_ID_ALLPAGE, 
    ADMILL_SCRIPT_ID_REGISTER, 
    ADMILL_NOSCRIPT_ID_REGISTER
}


// WEBPACK FOOTER //
// ./src/app/common/Hooks/useScriptInjector/constant.js